import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { List, Checkbox } from "antd";
import { useLocation } from "react-router";
import queryString from "query-string";
import Pitch from "../Pitch/Pitch";
import { searchPitchesAction } from "../../actions/search.action";
import Localize from "../../libs/localization";
import useListSelection from "../../hooks/useListSelection";
import ListLoader from "../ListLoader/ListLoader";

const PitchList = (props) => {
  const {
    pitchList,
    pageSize: propPageSize,
    setPageSize: propSetPageSize,
    total,
    onMoreBrandClick,
    loadingList,
    filters = "",
    tagMode = false,
    setSelectedPitch = () => {},
    isTagPage = false,
    loadingTag,
    associatedTagsIds,
    setPitchTagPage,
    onTagRemove = () => {},
    page = 1,
    isDashboard = false,
  } = props;

  const [internalPageSize, setInternalPageSize] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [selection, setSelection] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  // Use controlled pageSize if provided, otherwise use internal state
  const pageSize = propPageSize !== undefined ? propPageSize : internalPageSize;
  const setPageSize = propSetPageSize || setInternalPageSize;

  const { deselectAll, addToSelection, removeFromSelection } = useListSelection(
    {
      selection,
      setSelection,
    },
  );

  const dispatch = useDispatch();
  const location = useLocation();

  const fetchData = (page_, pageSize_) => {
    if (!isTagPage && !isDashboard && !loadingList) {
      const query = queryString.parse(location.search);
      let params = "";

      if (filters) {
        params = {
          ...filters,
          pageNum: page_,
          limit: pageSize_,
        };
      }

      if (query.key && !params.name) {
        params = {
          name: query.key,
          pageNum: page_,
          limit: pageSize_,
        };
      }

      dispatch(
        searchPitchesAction({
          data: params,
        }),
      );
    }
  };

  useEffect(() => {
    fetchData(1, pageSize);
  }, [location.key]);

  useEffect(() => {
    setCurrentPage(1);
  }, [filters]);

  useEffect(() => {
    setSelectedPitch(selection);
  }, [selection]);

  useEffect(() => {
    deselectAll();
    setSelectAll(false);
  }, [tagMode]);

  return (
    <>
      {loadingList ? (
        <ListLoader />
      ) : (
        <div>
          {tagMode && (
            <Checkbox
              checked={selectAll}
              onChange={(e) => {
                setSelectAll(e.target.checked);
                const ids = pitchList.map((pitch) => pitch._id);
                if (e.target.checked) {
                  addToSelection(ids);
                } else {
                  removeFromSelection(ids);
                }
              }}
            >
              {Localize("COMMON.SELECT_ALL")}
            </Checkbox>
          )}
          <List
            className="searchPage__list animation"
            itemLayout="horizontal"
            dataSource={pitchList}
            pagination={{
              onChange: (page, pageSize_) => {
                setSelectAll(false);
                setCurrentPage(page);
                setPageSize(pageSize_);
                if (setPitchTagPage) setPitchTagPage(page);
                fetchData(page, pageSize_);
              },
              current: page || currentPage,
              pageSize,
              total,
              showSizeChanger: !isTagPage,
            }}
            renderItem={(item) => {
              return (
                <div className="searchPage__item-more animation fadein-right slow">
                  <List.Item
                    className="searchPage__item pl-3"
                    style={{
                      backgroundColor: "white",
                      borderRadius: 10,
                      marginBottom: 15,
                    }}
                  >
                    <List.Item.Meta
                      size="small"
                      description={
                        <Pitch
                          isPitchPage
                          item={item}
                          onMoreBrandClick={onMoreBrandClick}
                          tagMode={tagMode}
                          setSelectedPitch={setSelection}
                          loadingTag={loadingTag}
                          associatedTagsIds={associatedTagsIds}
                          selectedPitches={selection}
                          onTagRemove={onTagRemove}
                        />
                      }
                    />
                  </List.Item>
                </div>
              );
            }}
          />
        </div>
      )}
    </>
  );
};

export default PitchList;
